// EditPost.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from './api'; // Use your API instance
import './styles.css';

const EditPost = () => {
    const { id } = useParams(); // Get post ID from URL parameters
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await API.get(`posts/${id}/`);
                setTitle(response.data.title);
                setContent(response.data.content);
            } catch (err) {
                console.error('Failed to fetch post', err);
                setError('Failed to fetch post details');
            }
        };

        fetchPost();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await API.put(
                `posts/${id}/`, // Update post endpoint
                { title, content } // Data to update
            );
            if (response.status === 200) {
                window.location.href = '/django-posts'; // Redirect after successful update
            }
        } catch (err) {
            setError('Failed to update post');
        }
    };

    return (
        <div className="create-post-container">
            <div className="create-post-card">
                <h1>Edit Post</h1>
                <form onSubmit={handleSubmit} className="create-post-form">
                    <input
                        type="text"
                        placeholder="Post Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="create-post-input"
                    />
                    <textarea
                        placeholder="Post Content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows="6"
                        className="create-post-textarea"
                    />
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="create-post-button">Update Post</button>
                </form>
            </div>
        </div>
    );
};

export default EditPost;
